<script>
    export let updateBillingRulesPhase = () => {};
</script>

<div class="flex flex-col gap-y-4 p-6 w-full">
    <div class="flex flex-col gap-y-4">
        <div class="flex justify-center">
            <img src="/imgs/illi_1@2x.png" alt="img" />
        </div>

        <div class="flex flex-col gap-y-2">
            <p class="text-[16px]">Now, create your first billing rule.</p>
            <p class="text-[16px]">This will be your default billing rule.</p>
        </div>

        <p class="text-[16px]">
            To add more billing rules, go to the Settings page.
        </p>
    </div>

    <!-- svelte-ignore a11y-missing-attribute -->
    <!-- svelte-ignore a11y-missing-content -->
    <div class="flex w-full justify-center">
        <div class="tabs flex gap-x-4 pb-4">
            <a
                class="tab tab-bordered cursor-pointer"
                on:click|preventDefault={updateBillingRulesPhase(1)}
            />
            <a
                class="tab tab-bordered cursor-pointer"
                on:click|preventDefault={updateBillingRulesPhase(2)}
            />
            <a
                class="tab tab-bordered cursor-pointer"
                on:click|preventDefault={updateBillingRulesPhase(3)}
            />
            <a class="tab tab-bordered tab-active cursor-default" />
        </div>
    </div>

    <button
        class="btn btn-md btn-secondary"
        on:click|preventDefault={() => updateBillingRulesPhase(5)}
    >
        Next
    </button>
</div>

<style>
    img {
        width: 300px;
        height: 300px;
    }
</style>
